import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import MessageConstants from '../../../constants/MessageConstants.js'
import URLSearchParams from 'url-search-params'
import API from '../../../api/auth'

class QuickStart extends Component {

  constructor(props) {
    super(props)

    const defaultMessage = this.props.location.state ? this.props.location.state.message || '' : ''
    const redirect_uri = new URLSearchParams(this.props.location.search).get('redirect_uri')

    this.state = {
      error: null,
      email: '',
      message: defaultMessage,
      redirect_uri: redirect_uri
    }

    this.handleEmailInput = this.handleEmailInput.bind(this)
    this.submitQuickCreate = this.submitQuickCreate.bind(this)
  }

  submitQuickCreate(event) {
    event.preventDefault()

    const setCode = (response) => {
      if (response.status === 200){
        this.props.setCode(response.data.code)
      }
    }   

    const createCallback = (response) => {
      if (response.status === 200){
        const { accessToken } = response.data.accessToken
        API.sendReset(this.state.email)
        API.fetchOAuthCode(accessToken, this.props.clientId, this.props.redirectURI, setCode.bind(this))

      } else if (response.status === 400) {
        this.setState({ error: MessageConstants.LOGIN_BAD_INPUT })
      } else {
        this.setState({ error: MessageConstants.DEFAULT_SERVER_ERROR })
      }
    }

    API.createOrg(this.state.email, createCallback)
  }   

  handleEmailInput(event) {
    this.setState({email: event.target.value, error: ''})
  }


  render() {
    const { error } = this.state

    return (
      <div className="login-page">
        <p>Enter your email below and we will generate a new account for you, check your email for a link to set your password.</p>
        <form className="drift-form" onSubmit={this.submitQuickCreate}>
          <input onChange={this.handleEmailInput} className="large" type="email" placeholder="your email" required/>
          {error && <strong className="request-status error">{ error }</strong> }
          <button className="drift-button drift-button-primary medium" type="submit">Lets go!</button>
        </form>
        <p>Have an account already?  <Link to={{pathname: '/authorize/login', search: location.search }}>Login here.</Link></p>
      </div>
    )
  }
}

const QuickStartPage = withRouter(QuickStart)

export default QuickStartPage



// WEBPACK FOOTER //
// ./src/components/pages/QuickStart/index.js